module.exports = __webpack_public_path__ + "img/郑州办公室.327c14d2.jpg";